import { Typography } from "@mui/material";
import ActionMenu from "components/ActionMenu";
import BasicAccordion from "components/basic/BasicAccordion";
import { NestedField } from "components/form/input/NestedField";
import { ParamFieldsContainer } from "entity/Indicador/components/ParamFields";
import getAllTiposIndicador from "entity/TipoIndicador/all";
import { useCallback, useEffect, useState } from "react";

/**
 * Todos os parâmetros agrupados por tipo de indicador.
 */
function getAllParamsByGroupedTipo(TipoIndicador) {
    return TipoIndicador.indicadores.map((IndicadorClass) => {
        return {
            id: TipoIndicador.multTipo ? IndicadorClass.field + TipoIndicador.field : IndicadorClass.field,
            label: IndicadorClass.fullName,
            fields: IndicadorClass.paramFields(TipoIndicador.field),
        }
    })
}

/**
 * Editor de parâmetros no cliente.
 */
export default function ClienteParamEditor({ cliente, form }) {
    // const { showSuccess } = useNotification();
    // console.log('cliente', cliente)
    // let shorV = []
    // for (let index = 2711; index <= 2719; index++) {
    //     shorV.push("" + index)
    // }
    // for (const key in cliente.data) {
    //     if (Object.hasOwnProperty.call(cliente.data, key)) {
    //         const element = cliente.data[key];
    //         if (shorV.includes(element)) {
    //             console.log("======> " + key, element)
    //         }
    //     }
    // }
    // Parâmetros ainda não presentes no cliente que podem ser adicionados.
    const [addMenuItems, setAddMenuItems] = useState([]);
    // Campos para os parâmetros presentes no cliente.
    const [fields, setFields] = useState([]);
    // Último parâmetro modificado, para expandir seu accordion ou notificar remoção.
    const [lastChangedParam, setLastChangedParam] = useState();

    const addParam = useCallback(
        (param) => {
            if (param) {
                cliente.addParam(param.id);
                setLastChangedParam(param.id);
            }
        },
        [cliente]
    );

    const removeParam = useCallback(
        (param) => {
            cliente.removeParam(param.id);
            // Notifica effect de renderização.
            setLastChangedParam("del " + param.id);
        },
        [cliente]
    );

    useEffect(() => {
        const newAddMenuItems = []
        const newFields = []

        for (const TipoIndicador of getAllTiposIndicador()) {
            let indicadoresAux = []

            for (const param of getAllParamsByGroupedTipo(TipoIndicador)) {
                if (cliente.hasParam(param.id)) {
                    indicadoresAux.push(
                        <ParamFieldsContainer
                            key={param.id}
                            param={param}
                            defaultExpanded={param.id === lastChangedParam}
                            onDelete={() => removeParam(param)}
                        />
                    )
                } else { // parâmetro ainda não cadastrado pelo cliente
                    let index = newAddMenuItems.findIndex(item => item.subheader === TipoIndicador.fullName)

                    if (index >= 0) {
                        console.log("index >= 0 ", index >= 0);
                        newAddMenuItems[index].items = [param, ...newAddMenuItems[index].items]
                    } else {
                        console.log("index !== ", index);
                        newAddMenuItems.push({
                            subheader: TipoIndicador.fullName,
                            items: [param]
                        })
                    }
                }
            }

            if (indicadoresAux.length > 0) {
                newFields.push(
                    <BasicAccordion key={TipoIndicador.field} title={TipoIndicador.fullName} defaultExpanded={true}>
                        {indicadoresAux.map(ind => ind)}
                    </BasicAccordion>
                )
            }
        }

        setAddMenuItems(newAddMenuItems)
        setFields(newFields)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cliente, lastChangedParam, removeParam]);

    // const migrarParametros = () => {
    //     cliente.migrateLegacyParams(true);
    //     showSuccess("Parametros Migrados");
    //     setLastChangedParam("");
    // };

    // // TODO: (b_2089) 2º por aqui consigo mudar as propriedades através de um botão, mas não por useEffect ou onChange
    // const consoleEntity = () => {
    //     for (const param of getAllParams()) {
    //         if (cliente.hasParam(param.id)) {
    //             let indicadorClass = new param.fields._self();
    //             if (indicadorClass.presetPontosAmostrados) {
    //                 if (param.id === "ngv") {
    //                     // console.log('ngv', _.get(form.getValues(), `params.${param.id}`))
    //                     // console.log('fields', fields)
    //                     // console.log('fields',
    //                     // // fields[0]?.props?.param?.fields?.type()
    //                     // fields[0]
    //                     // )
    //                     // console.log('values', form.getValues().params)
    //                     // console.log('values', form.getValues().params.ngv)

    //                     console.log("form", form);
    //                     // console.log('fields', fields)
    //                 }
    //             }
    //         }
    //     }
    // };

    return (
        <>
            <ActionMenu
                label="Parâmetro"
                menuItems={addMenuItems}
                onClose={addParam}
                emptyMessage="Todos os parâmetros já foram adicionados."
                sx={{ m: 2 }}
            />
            {/* <Button onClick={migrarParametros}>Resetar Parametros Antigos</Button> */}
            {/*  <Button onClick={consoleEntity}>Console Entity</Button>*/}

            {/* {console.log("form", form.getValues().params)} */}
            <NestedField prefix={cliente.paramField}>{fields}</NestedField>
            {!fields.length && (
                <div>
                    <Typography>Nenhum parametro configurado para este cliente</Typography>
                </div>
            )}
        </>
    );
}
